<div class="row mt-3">
  <div class="col-md-11 offset-md-1 text-left col-12">
    <h1 class="title">MANAGE USER ACCOUNTS: <strong>All Projects</strong></h1>
  </div>
</div>
<div class="row mb-3">
  <div class="col-md-3 offset-md-1">
    <mat-form-field class="clear-form-field">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>
  <div class="col-md-3 offset-md-5">
    <button type="button"
            id="createAccountBtn"
            class="btn btn-primary btn-block odp-btn-home-menu"
            [routerLink]='["/account/edit"]'>
      Create New Account
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-11 offset-md-1">
    <!-- <div class="card-body"> -->


      <table mat-table matSort [dataSource]="userSource">

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
          <td mat-cell *matCellDef="let user">{{user.firstName}}</td>
        </ng-container>
  
        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
          <td mat-cell *matCellDef="let user">{{user.lastName}}</td>
        </ng-container>
  
        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let user">{{user.email}}</td>
        </ng-container>
  
        <!-- Active Column -->
        <ng-container matColumnDef="isEnabled">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
          <td mat-cell *matCellDef="let user">{{user.isEnabled ? 'Yes' : 'No'}}</td>
        </ng-container>
  
        <!-- Roles Column -->
        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let user">
            <div *ngFor="let role of user.roles">{{role}}</div>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
        <tr mat-row *matRowDef="let row; columns: columnNames;" (click)="editAccount(row.id)"></tr>
      </table>

      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100, 250]">
      </mat-paginator>

    <!-- </div> -->
  </div>
</div>
